import React, { Component } from 'react';
import { connect } from 'react-redux';;
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logout from '../../auth/logout';
import BadgeMenu from '@bit/super-mario.yoshi.badge-menu';
import firebase from "../../firebase/FirebaseProvider";
import './drawer.css';

class Drawer extends Component {
  render() {
    const { user } = this.props;
    return (
      <div className="drawer">
      {
        (user && user.user_id) ?
          <div>
            <BadgeMenu userId={user.user_id}
              userOverride={user}
              links={[
                {
                  text: 'Logout',
                  onClick: () => {
                    firebase.auth().signOut().then(function () {
                      self.props.history.push("/login");
                    }, function () {
                      alert("Error logging out");
                    });
                  }
                }
              ]}/>
          </div>
        :
        <Link to='/login'>
          <span>Login</span>
        </Link>
      }
      </div>
    )
  }
}

Drawer.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);